import * as types from './mutation-types'

export default {
    [types.SET_FINANCIAL_FACILITIES](state, financialFacilities) {
        state.financialFacilities = financialFacilities
    },
    [types.ADD_FINANCIAL_FACILITY](state, data) {
        state.financialFacilities = [data.financialFacility, ...state.financialFacilities]
    },

    [types.UPDATE_FINANCIAL_FACILITY](state, data) {
        let pos = state.financialFacilities.findIndex(financialFacility => financialFacility.id === data.financialFacility.id)
        state.financialFacilities.splice(pos, 1)
        state.financialFacilities = [data.financialFacility, ...state.financialFacilities]
    },

}
